import React from 'react';
import { View, Text, Dimensions, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { connect } from 'react-redux';
import SelectedScreen from './selectedAnswerScreen';


const { width, height } = Dimensions.get('window');
const indication = require('./../../assets/assets_png/indication.png');


class QuestionIndex extends React.Component{
    state ={
        showSelectedScreen: false,
    }
    render(){
        const{ activeQuestion, totalQuestions, testInfo} = this.props;
        const _activeQuestion = activeQuestion <= 1 ? `0${activeQuestion + 1}` : activeQuestion

        return(
        <>    
        <TouchableOpacity
            onPress={() =>{
                this.setState({
                    showSelectedScreen: true
                })
                }
            
            }
            hitSlop={{ top: 8, left: 8, bottom: 8, right: 8 }}
            style={styles.questionIndex}
        >
             
            <View style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center',flex: 1 }}>
                <Text style={{ fontSize: 12, color: 'rgba(0,0,0,.65)' }}>Total answered</Text>
                <Text style={{ fontSize: 22, fontWeight: '700', }}>{_activeQuestion}/{totalQuestions}</Text>
            </View>
            <View style={{ position: 'absolute', right: 4, bottom: 4}}>
                <Image source={indication} style={{ height: 20, width: 20 }} />            
            </View>
            </TouchableOpacity>
            {
                this.state.showSelectedScreen ?
                <SelectedScreen
                open={this.state.showSelectedScreen}
                activeQuestionId={testInfo.test[activeQuestion]?.id}
                handleClose={() => this.setState({showSelectedScreen: false })}
                />
                : null
            }
         </>   
        )
    }
}
const mapStateToProps = state =>  {     
    return{
        loading: state.testInfo && state.testInfo.loading,
        testInfo: state.testInfo && state.testInfo,
        testDuration: state.testInfo && state.testInfo.testDuration && state.testInfo.testDuration,
        testStartRemainingTime: state.testInfo && state.testInfo.totalResponse && state.testInfo.totalResponse.status && state.testInfo.totalResponse.status.time_remaining,
        error: state.testInfo && state.testInfo.error,
        errInfo: state.testInfo && state.testInfo.errorInfo && state.testInfo.errorInfo.response,
        errMessage: state.testInfo && state.testInfo.errorInfo && state.testInfo.errorInfo.response && state.testInfo.errorInfo.response.data && state.testInfo.errorInfo.response.data.message,
        remainingTime: state.testInfo && state.testInfo.errorInfo && state.testInfo.errorInfo.response && state.testInfo.errorInfo.response.data && state.testInfo.errorInfo.response.data['time Remaining'],
        isQuestionsUnavailable: state?.testInfo?.test?.length === 0,
        testInfo: state.testInfo,
        loading: state.testInfo && state.testInfo.loading,
        activeQuestion: state.testInfo && state.testInfo.activeQuestion,
        totalQuestions: state.testInfo && state.testInfo.test?.length,
        questionsInfo: state.testInfo && state.testInfo.questionsInfo && state.testInfo.questionsInfo || []
    }
   }


export default  connect(mapStateToProps, {})(QuestionIndex);
const styles = StyleSheet.create({
    questionIndex: {
        // width: (width / 2 - 21),
        width: '50%',
        height: '100%',
        backgroundColor: '#ffdb4d',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        // alignSelf: 'flex-end',
        borderTopStartRadius: 50,
        borderLeftWidth: 2.5,
        borderLeftColor: '#fff',
        marginRight: -12,
        borderTopColor: '#fff',
        borderTopWidth: 0.5
    },
    questionNo: {
        marginHorizontal: 15,
        borderBottomColor: 'rgba(0,0,0,0.6)',
        borderBottomWidth: 0.6,
        marginTop: 10,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10,
        marginBottom: 10,
    },
    flexRow: {
        // flex:1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12
    },
})
